// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import styles from './gateway_th.module.less';
import {Block} from './block';
// @ts-ignore
import {img_url} from '../img_url';
import cn from 'classnames';

interface i_gateway {
    cls?: string;
}

export const Gateway = ({cls}:i_gateway)=>{
    const {t} = useTranslation() as any;
    const img = img_url('gateway_phone.png');
    const img_2x = img_url('gateway_phone_2x.png');
    const img_block = <img data-src={img} data-srcset={`${img}, ${img_2x} 2x`}
      alt="gateway" className={cn('lazyload', styles.phone)}/>;
    const text_block = <Fragment>
      <h2>
        <Trans i18nKey="one_gateway">One gateway<br/><span
          className="color_text green">Endless entertainment</span></Trans>
      </h2>
      <p className={styles.text}>
        {t('content_at_the_tip_of_your_fingers.1')}
      </p>
    </Fragment>;
    return <Block text_position={'right'} img={img_block} cls={cls}
      text={text_block}/>;
};
